import { render } from "./SignupComponent.vue?vue&type=template&id=0bb2d506&scoped=true"
import script from "./SignupComponent.vue?vue&type=script&lang=js"
export * from "./SignupComponent.vue?vue&type=script&lang=js"

import "./SignupComponent.vue?vue&type=style&index=0&id=0bb2d506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb2d506"]])

export default __exports__